// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { BoxSize } from './box-size';
import { Shipment } from './shipment';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ShippingBox extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get externalPackageId(): string {
    return 'u' + this.shipmentId + 'p' + this.id;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Int32 FK boxSize */
  boxSizeId?: number;
  /** Decimal */
  height?: number;
  /** Decimal */
  length?: number;
  /** String(255) */
  packageApiIdentifier?: string;
  /** Binary */
  rowVersion!: any;
  /** Int32 FK shipment */
  shipmentId!: number;
  /** String */
  shippingLabel?: string;
  /** String(255) */
  trackingLabelApiIdentifier?: string;
  /** Decimal */
  weight?: number;
  /** String(4) */
  weightUoMId?: string;
  /** Decimal */
  width?: number;
  /** FK boxSizeId */
  boxSize!: BoxSize;
  /** FK shipmentId */
  shipment!: Shipment;
}

